import script from "./base-input.vue?vue&type=script&setup=true&lang=js"
export * from "./base-input.vue?vue&type=script&setup=true&lang=js"

import "./base-input.vue?vue&type=style&index=0&id=134364fa&lang=css&scoped=true"

import exportComponent from "/home/ubuntu/ciyc-web-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-134364fa"]])

export default __exports__